// VideoDetails.jsx
import React from "react";
import { Stack, Typography, Chip } from "@mui/material";
import dayjs from "dayjs";

export const VideoDetails = ({ video }) => {
  if (!video) return null;

  return (
    <Stack  sx={{ gap: 0.5, mt: 0.5 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        {video.title}
      </Typography>
      <Typography sx={{ color: "grey" }} variant="body1">
        {dayjs(video.dateCreated).format("MMMM DD, YY")}
      </Typography>
      <Typography>{video.description}</Typography>
      {video.categoryName ? (
        <span>
          <Chip
            size="small"
            sx={{
              borderRadius: "5px",
              fontWeight: "bold"
            }}
            label={video.categoryName}
          />
        </span>
      ) : null}
    </Stack>
  );
};
